import { Box, Icon, Text } from '@zillow/constellation-10';
import { IconAIMagicFilled } from '@zillow/constellation-icons';

import { useAiGeneratedFields } from '../../../../hooks/queries/useAiGeneratedFields';

export const AI_DRAFTING_FOOTER_TEXT = 'Working on property description & amenities';

const AiDraftingFooterStatus = () => {
  const { status } = useAiGeneratedFields();

  if (status !== 'waiting') {
    return null;
  }

  return (
    <Box
      data-testid="AiDraftingFooterStatus"
      aria-live="polite"
      css={{ display: 'flex', alignItems: 'center', gap: '200', minWidth: 0 }}
    >
      <Icon render={<IconAIMagicFilled />} size="sm" css={{ color: 'icon.accent.purple.strong', flexShrink: 0 }} />
      <Text
        textStyle="body-sm"
        css={{
          fontStyle: 'italic',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          backgroundImage:
            'linear-gradient(90deg, {colors.text.subtle} 40%, {colors.text.neutral} 50%, {colors.text.subtle} 60%)',
          backgroundSize: '200% 100%',
          backgroundClip: 'text',
          color: 'transparent',
          opacity: 0.6,
          animation: 'textShimmer 4s linear infinite',
          '@media (prefers-reduced-motion: reduce)': {
            animation: 'none',
            backgroundImage: 'none',
            color: 'text.subtle',
          },
        }}
      >
        {AI_DRAFTING_FOOTER_TEXT}
      </Text>
    </Box>
  );
};

export default AiDraftingFooterStatus;
